import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const BookingContext = createContext(null);

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
};

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("appointment");

  const openBooking = useCallback((t = "appointment") => {
    setType(t);
    setOpen(true);
  }, [setType, setOpen]);

  const value = useMemo(
    () => ({ open, setOpen, type, setType, openBooking }),
    [open, type, openBooking]
  );

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};
